import { useStoreMap } from 'effector-react'

import type { ChatAdmin } from '../api'
import { $chatAdmins } from '../model'

export function useChatAdmin(userId: string | undefined): ChatAdmin | null {
    const user = useStoreMap({
        store: $chatAdmins,
        keys: [userId],
        fn: (users, [userId]) => (userId ? (users[userId] ?? null) : null),
    })

    return user
}
